// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Charges_AddAction_Add_Content(
  $object: vaxiom_misc_fee_charge_templates_insert_input!
) {
  insert_vaxiom_misc_fee_charge_templates_one(object: $object) {
    id
  }
}

`